export default defineNuxtPlugin(() => {
  const auth = useAuth();
  const router = useRouter();
  const route = useRoute();

  // Make injected values reactive (important)
  const user = computed(() => auth.data.value?.user ?? null);
  const loggedIn = computed(() => auth.status.value === 'authenticated');

  // Prevent repeated redirects
  let redirected = false;

  const logout = async () => {
    await auth.signOut();
  };

  watch(
    () => auth.status.value,
    async (newStatus, oldStatus) => {
      // Only react when we *transition* from authenticated -> unauthenticated
      if (redirected) return;
      if (oldStatus === 'authenticated' && newStatus === 'unauthenticated') {
        redirected = true;

        const returnTo = encodeURIComponent(route.fullPath);
        await router.push(
          `/signin?callbackUrl=${returnTo}&sessionExpired=true`
        );
      }
    }
  );

  return {
    provide: {
      auth: {
        user,
        loggedIn,
        logout,
      },
    },
  };
});
